<template>
    <div>
        <ValidationObserver v-slot="{ invalid }" ref="observer">
            <b-form role="form" class="mt-4">
                <b-row>
                    <b-col cols="12"><h4>Monthly KPI Settings</h4></b-col>
                    <b-col cols="8" md="5">
                        <b-form-group label="Monthly Achievement Amount">
                            <b-form-input
                            v-model="form.kpi_achievement_amount_100"
                            @keydown="preventNonNumericInput"
                            type="text"
                            placeholder="Enter monthly achievement amount"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="4">
                        <b-form-group label="Kpi Date">
                            <el-date-picker
                                v-model="form.kpi_date"
                                type="month"
                                format="yyyy-MM"
                                value-format="yyyy-MM"
                                >
                            </el-date-picker>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-table-simple bordered responsive class="border-dark">
                            <b-thead class="text-center">
                                <b-tr class="bg-grey">
                                    <b-th>Title</b-th>
                                    <b-th>Below 50%</b-th>
                                    <b-th>50% - 99%</b-th>
                                    <b-th>100% & Abv.</b-th>
                                </b-tr>
                            </b-thead>
                            <b-tbody>
                                <b-tr class="input-row">
                                    <b-td>Achievement Percentage</b-td>
                                    <b-td class="px-0">
                                        <b-input-group append="%">
                                            <b-form-input type="text" v-model="form.kpi_achievement_percent_below_50" @keydown="preventNonNumericInput"></b-form-input>
                                        </b-input-group>
                                    </b-td>
                                    <b-td class="px-0">
                                        <b-input-group append="%">
                                            <b-form-input type="text" v-model="form.kpi_achievement_percent_50_to_99" @keydown="preventNonNumericInput"></b-form-input>
                                        </b-input-group>
                                    </b-td>
                                    <b-td class="text-center">100%</b-td>
                                </b-tr>
                                <b-tr v-if="form">
                                    <b-td>Achievement Amount (RM)</b-td>
                                    <b-td class="text-right">RM {{ form.kpi_achievement_amount_below_50 | moneyFormatter }}</b-td>
                                    <b-td class="text-right">RM {{ form.kpi_achievement_amount_50_to_99 | moneyFormatter }}</b-td>
                                    <b-td class="text-right">RM {{ form.kpi_achievement_amount_100 | moneyFormatter }}</b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </b-col>
                    <!-- <b-col cols="12"><h4>Token Rewards</h4></b-col>
                    <b-col cols="12">
                        <b-table-simple bordered responsive class="border-dark">
                            <b-thead class="text-center">
                                <b-tr class="bg-grey">
                                    <b-th>Title</b-th>
                                    <b-th>Token Amount</b-th>
                                    <b-th>Token Number</b-th>
                                </b-tr>
                            </b-thead>
                            <b-tbody>
                                <b-tr class="input-row">
                                    <b-td>Mortgage Specialist <br>Sales Executive <br>Sales Senior Advisor <br>Sales Support Executives</b-td>
                                    <b-td class="px-0">
                                        <b-input-group prepend="RM">
                                            <b-form-input type="text" v-model="token_form.msp_token_target_amount" @keydown="preventNonNumericInput"></b-form-input>
                                        </b-input-group>
                                    </b-td>
                                    <b-td class="px-0">
                                        <b-input-group>
                                            <b-form-input type="number" v-model="token_form.msp_token_number" @keydown="preventNonNumericInput"></b-form-input>
                                        </b-input-group>
                                    </b-td>
                                </b-tr>
                                <b-tr class="input-row">
                                    <b-td>Sales Manager <br>Senior Advisor Manager <br>Sales Support Manager</b-td>
                                    <b-td class="px-0">
                                        <b-input-group prepend="RM">
                                            <b-form-input type="text" v-model="token_form.sm_token_target_amount" @keydown="preventNonNumericInput"></b-form-input>
                                        </b-input-group>
                                    </b-td>
                                    <b-td class="px-0">
                                        <b-input-group>
                                            <b-form-input type="number" v-model="token_form.sm_token_number" @keydown="preventNonNumericInput"></b-form-input>
                                        </b-input-group>
                                    </b-td>
                                </b-tr>
                                <b-tr class="input-row">
                                    <b-td>Hub Manager</b-td>
                                    <b-td class="px-0">
                                        <b-input-group prepend="RM">
                                            <b-form-input type="text" v-model="token_form.hm_token_target_amount" @keydown="preventNonNumericInput"></b-form-input>
                                        </b-input-group>
                                    </b-td>
                                    <b-td class="px-0">
                                        <b-input-group>
                                            <b-form-input type="number" v-model="token_form.hm_token_number" @keydown="preventNonNumericInput"></b-form-input>
                                        </b-input-group>
                                    </b-td>
                                </b-tr>
                                
                            </b-tbody>
                        </b-table-simple>
                    </b-col> -->
                    <!-- <TokenRewards ref="token_reward"/> -->
                    <b-col cols="8">
                        <b-button block variant="primary" class="w-50" @click.prevent="update" :disabled="invalid">Save</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </ValidationObserver>
    </div>
</template>
<script>
import { Select, Option, RadioGroup, RadioButton, DatePicker } from 'element-ui'
import {
notifyFunctionMixin,
axios,
services,
getHeader,
} from '@/assets/js/httpImports.js'
import { mapActions, mapState } from 'pinia'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import '@/assets/js/formValidations.js'
import { useHubStore } from '@/stores/hubStore'
import TokenRewards from '@/views/Commission/Hub/HubProfile/OffCanvasDetails/DrawerHubCommissionSettings/TokenRewards'

export default {
    mixins:[
        notifyFunctionMixin,
    ],
    components: {
        TokenRewards,
        ValidationObserver,
        ValidationProvider,
        [Select.name]: Select,
        [Option.name]: Option,
        [RadioGroup.name]: RadioGroup,
        [RadioButton.name]: RadioButton,
        [DatePicker.name]: DatePicker,
    },
    watch: {
        form: {
            handler(newValue) {
                if(newValue)
                {
                    let kpi_achievement_amount_below_50 = newValue.kpi_achievement_amount_100 * newValue.kpi_achievement_percent_below_50 / 100;
                    let kpi_achievement_amount_50_to_99 = newValue.kpi_achievement_amount_100 * newValue.kpi_achievement_percent_50_to_99 / 100;
                    newValue.kpi_achievement_amount_below_50 = kpi_achievement_amount_below_50;
                    newValue.kpi_achievement_amount_50_to_99 = kpi_achievement_amount_50_to_99;
                }
            },
            deep:true,
        },
    },
    data() {
        return {
            form: {
                hub_team_member_kpi_id: null,
                hub_id: null,
                kpi_achievement_percent_below_50: null,
                kpi_achievement_amount_below_50: null,
                kpi_achievement_percent_50_to_99: null,
                kpi_achievement_amount_50_to_99: null,
                kpi_achievement_amount_100: null,
                kpi_date: '',
            },
            token_form: {
                hub_token_id: null,
                hub_id: null,
                msp_token_target_amount: null,
                msp_token_number: null,
                sm_token_target_amount: null,
                sm_token_number: null,
                hm_token_target_amount: null,
                hm_token_number: null,
            }
        };
    },
    computed: {
        ...mapState(useHubStore,['current_hub', 'current_team'])
    },
    created() {
        this.getHubKpiSetting();
        // this.getHubTokenSetting();
    },
    mounted() {
        const current_date = new Date();
        const year = current_date.getFullYear();
        const month = (current_date.getMonth() + 1).toString().padStart(2, '0');
        this.form.kpi_date = `${year}-${month}`;
    },
    methods: {
        preventNonNumericInput(event) {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);
            const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
            const allowedKeys = [8, 37, 38, 39, 40, 46];
            if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
                event.preventDefault();
            }
        },
        getHubKpiSetting() {
            if(this.$route.params.hub_id)
            {
                this.form.hub_id = this.current_hub.hub_id;
                axios.get(services.hub + 'hub_comms/hub_team_member_kpi/' + this.form.hub_id, {headers: getHeader()})
                .then(res => {
                    if(res.data.data.length > 0)
                    {
                        this.form = res.data.data;
                    }
                })
                .catch(e => {
                    this.errorFunction(e)
                })
            }
            else if(this.$route.params.hub_team_id)
            {
                this.form.hub_id = this.current_team.hub.hub_id;
                this.form.hub_team_id = this.$route.params.hub_team_id
                axios.get(services.hub + 'hub_comms/hub_team_member_kpi.show_by_hub_team_id/' + this.$route.params.hub_team_id, {headers: getHeader()})
                .then(res => {
                    if(res.data.data.length > 0)
                    {
                        this.form = res.data.data[0];
                        this.is_team = true;
                        this.hub_team_member_kpi_id = res.data.data[0].hub_team_member_kpi_id;
                    }
                })
                .catch(e => {
                    this.errorFunction(e)
                })
            }

            // axios.get(services.hub + 'hub_comms/hub_team_member_kpi/' + this.form.hub_id, {headers: getHeader()})
            // .then(res => {
            //     if(res.data.data.length > 0)
            //     {
            //         this.form = res.data.data[0];
            //         this.hub_team_member_kpi_id = res.data.data[0].hub_team_member_kpi_id;
            //     }
            // })
            // .catch(e => {
            //     this.errorFunction(e)
            // })
        },
        getHubTokenSetting() {
            axios.get(services.hub + 'hub_comms/hub_token/' + this.form.hub_id, {headers: getHeader()})
            .then(res => {
                if(res.data.data.length > 0)
                {
                    this.token_form = res.data.data[0];
                }
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
        updateTokenSetting() {
            for (let key in this.form) {
                this.form[key] = parseFloat(this.form[key]);
            }
            this.token_form.hub_id = this.form.hub_id;
            
            const postData = this.token_form;

            if(this.token_form.hub_token_id)
            {
                axios.put(services.hub + 'hub_comms/hub_token/' + this.token_form.hub_token_id, postData, {headers: getHeader()})
                .then(res => {
                    if(res.status == 200)
                    {
                        this.notifySuccess('<b>Hub Token Setting </b> - Successfully Updated.')
                        this.getHubTokenSetting()
                    }
                })
                .catch(e => {
                    this.errorFunction(e)
                })
            }
            else
            {
                axios.post(services.hub + 'hub_comms/hub_token', postData, {headers: getHeader()})
                .then(res => {
                    if(res.status == 200)
                    {
                        this.notifySuccess('<b>Hub Token Setting </b> - Successfully Created.')
                        this.getHubTokenSetting()
                    }
                })
                .catch(e => {
                    this.errorFunction(e)
                })
            }
        },
        update() {
            for (let key in this.form) {
                if (this.form.hasOwnProperty(key)) {
                    if (key !== 'kpi_date' && key !== 'created_at' && key !== 'updated_at') {
                        this.form[key] = parseFloat(this.form[key]);
                    } else if (key === 'kpi_date') {
                        const dateParts = this.form.kpi_date.split('-');
                        if(dateParts.length !== 3)
                        {
                            this.form.kpi_date = this.form.kpi_date + '-01';
                        }
                    }
                }
            }
            this.form.hub_team_id = this.$route.params.hub_team_id;
            const postData = this.form;
            console.log('data', postData);

            axios.post(services.hub + 'hub_comms/hub_team_member_kpi', postData, {headers: getHeader()})
            .then(res => {
                if(res.status == 200)
                {
                    this.notifySuccess('<b>Hub Kpi Setting </b> - Successfully Created.')
                    this.getHubKpiSetting()
                }
            })
            .catch(e => {
                this.errorFunction(e)
            })

            // this.updateTokenSetting();
            // this.$refs.token_reward.updateTokenSetting();

        },
    }
}
</script>